var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pcg-search',{staticClass:"m-0",attrs:{"placeholder":_vm.$t('general.search'),"value":_vm.query},on:{"input":_vm.updateQuery}})}
var staticRenderFns = []

export { render, staticRenderFns }